var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.position.lat !== 0 || _vm.position.lng !== 0)?_c('gmap-marker',{attrs:{"position":_vm.position,"icon":_vm.getMarkerIcon()},on:{"click":_vm.handleMarkerClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }